import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { flow, get, startsWith, has } from 'lodash';
import TextArea from '../TextArea/TextArea';
import QuestionForm from '../QuestionsForm/QuestionForm';
import displayName from '../../../../helpers/displayName';
import { FormGroup, Row, Col, ControlLabel, Form } from 'react-bootstrap';
import { openModal } from '../../../../common/components/Modal/ModalRedux';
import {
  clearFiles,
  setUploadAccept,
} from '../../../../common/components/Upload/UploadRedux';
import { Field, FieldArray, getFormValues, reduxForm } from 'redux-form';
import { CheckboxGroup, RadioGroup } from '../../../../common/components/ReduxFormField';
import { UploadModal } from '../../../../common/components/Upload/UploadModal';
import {
  Box,
  Button,
  ButtonBar,
  DatePicker,
  HorizontalFormControl,
  Upload,
} from '../../../../common/components';
import './ContentForm.scss';
import { Questions } from '../../../whitelabel/components/Faqs/Faqs';

const FORM_NAME = 'contentForm';
const normaliseSlug = (templateType) => (slug) => {
  if (templateType === 'article') {
    return !startsWith(slug, '/blog/') ? `/blog/${slug}` : slug;
  }
  return slug;
};

class ContentForm extends Component {
  constructor() {
    super();

    this.state = {
      uploadKey: null,
    };
  }

  resetState() {
    const { dispatch } = this.props;

    this.setState({ uploadKey: null });
    dispatch(clearFiles());
  }

  componentDidMount() {
    const { template, dispatch, change, resource } = this.props;
    dispatch(change('data.relationships.template.data', template));
    if (template.attributes.key === 'article' && !has(resource, 'data.attributes.slug')) {
      dispatch(change('data.attributes.slug', '/blog/'));
    }
  }

  handleTitleChange() {
    const { dispatch, change, formValues } = this.props;
    dispatch(change('data.attributes.sections.title', formValues.data.attributes?.name));
  }

  handleUploadComplete(key = '') {
    const { dispatch, resource, change, files } = this.props;
    const { uploadKey } = this.state;
    const file = files[files.length - 1];

    if (!file) {
      return;
    }

    dispatch(
      change(
        `data.attributes.sections.${uploadKey ? uploadKey : key}.[${file.id}].name`,
        file.attributes.name,
      ),
    );
    dispatch(
      change(
        `data.attributes.sections.${uploadKey ? uploadKey : key}.[${file.id}].url`,
        file.attributes.url,
      ),
    );
    dispatch(
      change('data.relationships.files.data', [
        ...resource.data.relationships.files.data,
        file,
      ]),
    );

    this.resetState();
  }

  handleUpload(uploadKey) {
    return () => {
      const { dispatch } = this.props;
      dispatch(setUploadAccept('*'));
      dispatch(openModal(UploadModal.MODAL_IDENTIFIER));

      this.setState({ uploadKey });
    };
  }

  getFileName(path) {
    const { resource, formValues } = this.props;
    const fileId = get(formValues, path);

    if (!fileId) {
      return null;
    }

    let files = [];

    if (formValues.data.relationships.files) {
      files = formValues.data.relationships.files.data.filter((file) => {
        return file.id === fileId && file.attributes;
      });
    }

    if (files.length === 0 && resource.included) {
      files = resource.included.filter((file) => {
        return file.id === fileId && file.type === 'files';
      });
    }

    if (typeof fileId === 'object' && !Array.isArray(fileId)) {
      return (
        <div className="content-show-section">
          <div className="RichEditor-root">
            {Object.keys(fileId).map(function(key) {
              return (
                <div>
                  <a href={fileId[key].url} target={'_blank'}>
                    {fileId[key].name}
                  </a>
                </div>
              );
            })}
          </div>
        </div>
      );
    }

    if (formValues.included) {
      return formValues.included.map((item) => {
        if (item.type === 'files') {
          return item.attributes.name;
        }
        return null;
      });
    }

    return files.length > 0 ? files[0].attributes.name : null;
  }

  render() {
    const { template, handleSubmit, submitting, formValues } = this.props;
    const includeSlug = ['article', 'page'];

    const getInputType = (key, options, name) => {
      switch (options.fieldtype) {
        case 'date':
          return (
            <div>
              <FormGroup>
                <Col sm={2}>
                  <ControlLabel>{displayName(key)}</ControlLabel>
                </Col>
                <Col sm={10}>
                  <Field
                    name={name}
                    placeholder={displayName(key)}
                    component={DatePicker}
                  />
                </Col>
              </FormGroup>
            </div>
          );

        case 'checkbox':
          return (
            <Field
              name={name}
              label={displayName(key)}
              component={CheckboxGroup}
              inline={true}
              labelSize={2}
              options={[{ label: '', value: true }]}
            />
          );

        case 'text':
          return (
            <Field
              name={name}
              label={displayName(key)}
              placeholder={displayName(key)}
              labelSize={2}
              component={HorizontalFormControl}
            />
          );

        case 'event':
          return (
            <div key={key} className="row form-group hidden">
              <div className="col-sm-12 form-horizontal">
                <Field
                  name={name}
                  label={displayName(key)}
                  placeholder={displayName(key)}
                  labelSize={2}
                  component={HorizontalFormControl}
                />
              </div>
            </div>
          );

        case 'file':
          return (
            <FormGroup key={key}>
              <Col sm={2}>
                <ControlLabel>{displayName(key)}</ControlLabel>
              </Col>
              <Col sm={10}>
                {this.getFileName(name)}
                <Upload
                  onComplete={::this.handleUploadComplete(key)}
                  width={200}
                  height={200}
                  bsStyle="primary"
                  circle={true}
                >
                  Upload File
                </Upload>
                {template.attributes.template_type === 'article' &&
                  '.jpg .jpeg .png (min: 720x420px)'}
              </Col>
            </FormGroup>
          );

        case 'textarea':
          return (
            <div key={key} className="row form-group">
              <div className="col-sm-12 form-horizontal">
                <div className="row">
                  <div className="col-sm-2">
                    <div className="control-label">{displayName(key)}</div>
                  </div>
                  <div className="col-sm-10">
                    <Field
                      name={name}
                      placeholder={displayName(key)}
                      labelSize={2}
                      type="textarea"
                      resource={this.props.resource}
                      component={TextArea}
                    />
                  </div>
                </div>
              </div>
            </div>
          );

        case 'textarea_array':
          return (
            <div key={key} className="row form-group">
              <div className="col-sm-12 form-horizontal">
                <Field name={name} labelSize={2} colSize={12} component={Questions} />
              </div>
            </div>
          );
        case 'questions':
          return (
            <div key={key} className="row form-group">
              <div className="col-sm-12 form-horizontal">
                <FieldArray
                  name={name}
                  labelSize={2}
                  type={key}
                  data={get(formValues, name)}
                  resource={this.props.resource}
                  component={QuestionForm}
                />
              </div>
            </div>
          );

        case 'markdown':
        default:
          return (
            <div key={key}>
              <label htmlFor={key} className="control-label">
                {displayName(key)}
              </label>
              <Field
                name={name}
                label={displayName(key)}
                placeholder={displayName(key)}
                labelSize={2}
                component={TextArea}
              />
            </div>
          );
      }
    };

    return (
      <Box className={'content-form'}>
        <h2>Content Details</h2>
        {template.id ? (
          <Form horizontal onSubmit={handleSubmit}>
            <Field
              name="data.attributes.name"
              label="Title"
              placeholder="Add a unique name for this content..."
              labelSize={2}
              onBlur={() => this.handleTitleChange()}
              component={HorizontalFormControl}
            />
            {/* PRIORITY OPTIONS */}
            {template.attributes.template_type !== 'article' && (
              <div className="row form-group">
                <div className="col-sm-12">
                  <div className="row form-group">
                    {template.attributes.template_type !== 'question' && (
                      <Field
                        name="data.attributes.metadata.priority"
                        label="Priority"
                        component={CheckboxGroup}
                        inline={true}
                        labelSize={2}
                        options={[{ label: 'High Alert', value: true }]}
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
            {template.attributes.template_type === 'announcement' && (
              <div>
                <div className={'d-none'}>
                  <Field
                    name="data.attributes.announcement_type"
                    label="Type"
                    component={RadioGroup}
                    inline={true}
                    labelSize={2}
                    options={[
                      { label: 'Automatic', value: 'auto' },
                      { label: 'Temporary', value: 'temporary' },
                    ]}
                  />
                </div>
                <Row>
                  <Col sm={2}>
                    <ControlLabel>Display Between</ControlLabel>
                  </Col>
                  <Col sm={10}>
                    <div className={'date-group'}>
                      <Field
                        name="data.attributes.from_date"
                        minDateToday={true}
                        component={DatePicker}
                      />
                      <span className={'to-label'}>to</span>
                      <Field
                        name="data.attributes.to_date"
                        minDate={get(formValues, 'data.attributes.to_date')}
                        component={DatePicker}
                      />
                    </div>
                  </Col>
                </Row>
                <div className={'d-none'}>
                  <Field
                    name="data.attributes.duration"
                    label="Fixed Announcement"
                    component={RadioGroup}
                    inline={true}
                    labelSize={2}
                    options={[
                      { label: '3 days', value: 3 },
                      { label: '7 days', value: 7 },
                      { label: '14 days', value: 14 },
                    ]}
                  />
                </div>
                {get(formValues, 'data.attributes.duration') > 0 && (
                  <Field
                    name="data.attributes.event"
                    label="Prompt"
                    component={RadioGroup}
                    inline={true}
                    labelSize={2}
                    options={[
                      { label: 'Account opened', value: 'broker_approved' },
                      { label: 'User added', value: 'user_created' },
                    ]}
                  />
                )}
              </div>
            )}

            {includeSlug.indexOf(template.attributes.template_type) !== -1 && (
              <div>
                <Field
                  name="data.attributes.slug"
                  label="Slug"
                  placeholder="ex: /blog/new-article-name"
                  labelSize={2}
                  fieldSize={8}
                  component={HorizontalFormControl}
                  normalize={normaliseSlug(template.attributes.template_type)}
                />
                <Row>
                  <Col sm={12} smOffset={2} className="help-block">
                    The Url slug can only contain letters, numbers and hyphens
                  </Col>
                </Row>
              </div>
            )}

            {Object.keys(template.attributes.sections).map((section) => {
              return getInputType(
                section,
                template.attributes.sections[section],
                'data.attributes.sections.' + section,
              );
            })}
            <ButtonBar>
              <Button
                type="submit"
                bsStyle="primary"
                className="pull-right"
                disabled={submitting}
              >
                {submitting ? <i className="fa fa-cog fa-spin" /> : ''} Save Content
              </Button>
            </ButtonBar>
          </Form>
        ) : (
          <p>Please select a template to continue...</p>
        )}

        {/*<UploadModalComponent*/}
        {/*  onComplete={::this.handleUploadComplete}*/}
        {/*  accept={uploadAccept}*/}
        {/*/>*/}
      </Box>
    );
  }
}

ContentForm.propTypes = {
  dispatch: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  formValues: PropTypes.object,
  resource: PropTypes.object,
};
export default flow(
  reduxForm({
    form: FORM_NAME,
  }),
  connect((state, props) => {
    return {
      formValues: getFormValues(FORM_NAME)(state),
      initialValues: props.resource,
      files: state.upload.files,
      uploadAccept: state.upload.accept,
      template: props.template ? props.template : state.content.template,
    };
  }),
)(ContentForm);
